import { ref } from 'vue'
import { Role } from '@gohighlevel/ghl-proposals-common'

/**
 * Shared state for the Add/Edit Role modal used across the fillable-element property panels.
 * `roleToEdit` is null in add mode and the target role in edit mode.
 */
export const useRoleModal = () => {
  const showAddRoleModal = ref(false)
  const roleToEdit = ref<Role | null>(null)

  const openAddRole = () => {
    roleToEdit.value = null
    showAddRoleModal.value = true
  }

  const openEditRole = (role: Role) => {
    roleToEdit.value = role
    showAddRoleModal.value = true
  }

  return { showAddRoleModal, roleToEdit, openAddRole, openEditRole }
}
